import {RouterModule, Routes} from '@angular/router';
import {SettingsClientCustomGridComponent} from './components/grid/settings-client-custom-grid.component';
import {MasterDataLayoutEditorComponent} from './components/master-data-layout-editor/master-data-layout-editor.component';
import {GridRendererEditorComponent} from './components/grid-renderer-editor/grid-renderer-editor.component';
import {permission} from './settings-client-custom.permission';

const requiredPermissions = [
  permission.MYMEDAX_SETTING_CREATE,
  permission.MYMEDAX_SETTING_READ,
  permission.MYMEDAX_SETTING_UPDATE,
  permission.MYMEDAX_SETTING_DELETE
];

const APP_ROUTES: Routes = [
  {
    path: 'module/settings/master-data',
    component: MasterDataLayoutEditorComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsPermissions: requiredPermissions
    }
  },
  {
    path: 'module/settings/master-data/custom-fields',
    component: SettingsClientCustomGridComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsPermissions: requiredPermissions
    }
  },
  {
    path: 'module/settings/master-data/grid-renderer',
    component: GridRendererEditorComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsPermissions: requiredPermissions
    }
  }
];

export const routing = RouterModule.forRoot(APP_ROUTES);

